<template>
  <div>
    <h1 class="d-flex align-items-center g-3 mb-4">
      <i class="fas fa-home text-primary"></i>
      <span>{{ translate("home") }}</span>
    </h1>
    <div class="row g-4">
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-column g-4">
              <h2 class="d-flex align-items-center g-3 mb-0">
                <i class="fas fa-users text-primary"></i>
                <span>{{ translate("communities") }}</span>
              </h2>
              <div style="font-size: 0.95em">{{ translate("communities.description") }}</div>
              <div class="d-flex align-items-center g-4">
                <ButtonView type="normal" color="primary" class="w-100" :route="{ name: 'communities.create' }">
                  <div class="d-flex align-items-center justify-content-center g-2">
                    <i class="fas fa-plus"></i>
                    <span>{{ translate('create') }}</span>
                  </div>
                </ButtonView>
                <ButtonView type="normal" color="secondary" class="w-100" :route="{ name: 'user.communities', params: { userId: info.user.id } }">
                  <div class="d-flex align-items-center justify-content-center g-2">
                    <i class="fas fa-list"></i>
                    <span>{{ translate('view') }}</span>
                  </div>
                </ButtonView>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-column g-4">
              <h2 class="d-flex align-items-center g-3 mb-0">
                <i class="fas fa-user text-primary"></i>
                <span>{{ translate("profile") }}</span>
              </h2>
              <div style="font-size: 0.95em">{{ translate("user.profile.description") }}</div>
              <ButtonView type="normal" color="secondary" class="w-100" :route="{ name: 'user', params: { userId: user.id }}">
                {{ translate('view') }}
              </ButtonView>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "@/info";
import {ButtonView} from "@niftybit/vue";

export default {
  name: "HomePage",
  components: {ButtonView},
  computed: {
    info() {
      return info
    },
    user() {
      return info.user;
    }
  },
  methods: {
    openKnowledgeBase() {
      window.open("https://docs.vactar.io", '_blank');
    }
  }
}
</script>

<style scoped>

</style>